module.exports = __webpack_public_path__ + "img/no.fefa5033.jpg";